import dhtmlxArray from './dhtmlxArray';
import  dhtmlXGridObject from './dhtmlXGridObject';

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var t_creator = function (name) {
    var t = document.createElement("TABLE");
    t.cellSpacing = t.cellPadding = 0;
    t.style.cssText = "width:100%;table-layout:fixed;";
    t.className = name.substr(2);
    return t;
};


/**
 * 去掉前后空格
 * @private
 */
String.prototype._dhx_trim = function () {
    return this.replace(/&nbsp;/g, " ").replace(/(^[ \t]*)|([ \t]*$)/g, "");
};
function dhtmlXGridFromTable(obj, init) {
    if (typeof obj != "object") {
        obj = document.getElementById(obj);
    }
    var w = document.createElement("DIV");
    w.setAttribute("width", obj.getAttribute("gridWidth") ||
        (obj.offsetWidth ? obj.offsetWidth + "px" : 0) ||
        (window.getComputedStyle
            ? window.getComputedStyle(obj, null)["width"]
            : obj.currentStyle
                ? obj.currentStyle.width
                : 0));
    w.setAttribute("height", obj.getAttribute("gridHeight") ||
        (obj.offsetHeight ? obj.offsetHeight + "px" : 0) ||
        (window.getComputedStyle
            ? window.getComputedStyle(obj, null)["height"]
            : obj.currentStyle
                ? obj.currentStyle.height
                : 0));
    w.className = obj.className;
    obj.className = "";
    if (obj.id) {
        w.id = obj.id;
    }
    var mr = obj;
    var drag = obj.getAttribute("dragAndDrop");
    mr.parentNode.insertBefore(w, mr);
    var f = mr.getAttribute("name") || "name_" + new Date().valueOf();
    var windowf = new dhtmlXGridObject(w);
    window[f] = windowf;
    var acs = mr.getAttribute("onbeforeinit");
    var acs2 = mr.getAttribute("oninit");
    if (acs) {
        eval(acs);
    }
    windowf.setImagePath(windowf.imgURL ||
        (mr.getAttribute("imgpath") || mr.getAttribute("image_path") || ""));
    var skin = mr.getAttribute("skin");
    if (skin) {
        windowf.setSkin(skin);
    }
    if (init) {
        init(windowf);
    }
    var hrow = mr.rows[0];
    var za = [];
    var zb = "";
    var zc = "";
    var zd = "";
    var ze = "";
    for (var i = 0; i < hrow.cells.length; i++) {
        za.push(hrow.cells[i].innerHTML);
        var width = hrow.cells[i].getAttribute("width") ||
            hrow.cells[i].offsetWidth ||
            (window.getComputedStyle
                ? window.getComputedStyle(hrow.cells[i], null)["width"]
                : hrow.cells[i].currentStyle
                    ? hrow.cells[i].currentStyle.width
                    : 0);
        zb += (zb ? "," : "") + (width == "*" ? width : parseInt(width));
        zc += (zc ? "," : "") + (hrow.cells[i].getAttribute("align") || "left");
        zd += (zd ? "," : "") + (hrow.cells[i].getAttribute("type") || "ed");
        ze += (ze ? "," : "") + (hrow.cells[i].getAttribute("sort") || "str");
        var f_a = hrow.cells[i].getAttribute("format");
        if (f_a) {
            if (hrow.cells[i]
                .getAttribute("type")
                .toLowerCase()
                .indexOf("calendar") != -1) {
                windowf._dtmask = f_a;
            }
            else {
                windowf.setNumberFormat(f_a, i);
            }
        }
    }
    windowf.setHeader(za);
    windowf.setInitWidths(zb);
    windowf.setColAlign(zc);
    windowf.setColTypes(zd);
    windowf.setColSorting(ze);
    if (obj.getAttribute("gridHeight") == "auto") {
        windowf.enableAutoHeigth(true);
    }
    if (obj.getAttribute("multiline")) {
        windowf.enableMultiline(true);
    }
    var lmn = mr.getAttribute("lightnavigation");
    if (lmn) {
        windowf.enableLightMouseNavigation(lmn);
    }
    var evr = mr.getAttribute("evenrow");
    var uevr = mr.getAttribute("unevenrow");
    if (evr || uevr) {
        windowf.enableAlterCss(evr, uevr);
    }
    if (drag) {
        windowf.enableDragAndDrop(true);
    }
    windowf.init();
    if (obj.getAttribute("split")) {
        windowf.splitAt(obj.getAttribute("split"));
    }
    windowf.callEvent("onXLS", []);
    windowf._process_inner_html(mr, 1);
    if (acs2) {
        eval(acs2);
    }
    if (obj.parentNode && obj.parentNode.removeChild) {
        obj.parentNode.removeChild(obj);
    }
    windowf.callEvent("onXLE", []);
    return windowf;
}
var dhtmlXGridComboObject = (function () {
    function dhtmlXGridComboObject() {
        this.keys = new dhtmlxArray();
        this.values = new dhtmlxArray();
        return this;
    }
    dhtmlXGridComboObject.prototype.put = function (c, e) {
        for (var a = 0; a < this.keys.length; a++) {
            if (this.keys[a] == c) {
                this.values[a] = e;
                return true;
            }
        }
        this.values[this.values.length] = e;
        this.keys[this.keys.length] = c;
    };
    dhtmlXGridComboObject.prototype.get = function (c) {
        for (var a = 0; a < this.keys.length; a++) {
            if (this.keys[a] == c) {
                return this.values[a];
            }
        }
        return null;
    };
    dhtmlXGridComboObject.prototype.clear = function () {
        this.keys = new dhtmlxArray();
        this.values = new dhtmlxArray();
    };
    dhtmlXGridComboObject.prototype.remove = function (c) {
        for (var a = 0; a < this.keys.length; a++) {
            if (this.keys[a] == c) {
                this.keys._dhx_removeAt(a);
                this.values._dhx_removeAt(a);
                return true;
            }
        }
    };
    dhtmlXGridComboObject.prototype.size = function () {
        var a = 0;
        for (var c = 0; c < this.keys.length; c++) {
            if (this.keys[c] != null) {
                a++;
            }
        }
        return a;
    };
    dhtmlXGridComboObject.prototype.getKeys = function () {
        var a = new Array(0);
        for (var c = 0; c < this.keys.length; c++) {
            if (this.keys[c] != null) {
                a[a.length] = this.keys[c];
            }
        }
        return a;
    };
    dhtmlXGridComboObject.prototype.save = function () {
        this._save = new Array();
        for (var a = 0; a < this.keys.length; a++) {
            this._save[a] = [this.keys[a], this.values[a]];
        }
    };
    dhtmlXGridComboObject.prototype.restore = function () {
        if (this._save) {
            this.keys[0] = new Array();
            this.values[0] = new Array();
            for (var a = 0; a < this._save.length; a++) {
                this.keys[a] = this._save[a][0];
                this.values[a] = this._save[a][1];
            }
        }
    };
    return dhtmlXGridComboObject;
})();
var Hashtable = (function (_super) {
    __extends(Hashtable, _super);
    function Hashtable() {
        _super.call(this);
        this.keys = new dhtmlxArray();
        this.values = new dhtmlxArray();
        return this;
    }
    return Hashtable;
})(dhtmlXGridComboObject);

var globalObj={
    globalActiveDHTMLGridObject:null
};

export {t_creator,__extends,Hashtable,dhtmlXGridComboObject,dhtmlXGridFromTable,globalObj};



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dXGridObject/dxGridComClass.js